module.exports = __webpack_public_path__ + "img/m-icon1.70664e1b.png";